// DAT-25: SBA public data on RegistryRecordService (browser path, viewer auth).
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { registryRecordClient } from '../registryRecordClient';
function useViewerKey() {
    const { user } = useAuth();
    return `${user?.tenant_id ?? ''}:${user?.id ?? ''}`;
}
export const sbaKeys = {
    all: [
        'registry',
        'sba'
    ],
    profile: (viewer, id)=>[
            ...sbaKeys.all,
            'profile',
            viewer,
            id
        ],
    badges: (viewer, ids)=>[
            ...sbaKeys.all,
            'badges',
            viewer,
            ids
        ]
};
/** GetCompanySbaProfile: certifications, NAICS small flags, agreements, SBS link. */ export function useCompanySbaProfile(companyId) {
    const viewer = useViewerKey();
    return useQuery({
        queryKey: sbaKeys.profile(viewer, companyId),
        queryFn: ()=>registryRecordClient.getCompanySbaProfile({
                companyId,
                includeEnded: true
            }),
        enabled: !!companyId,
        retry: false,
        staleTime: 5 * 60000
    });
}
/** ListCompanySbaBadges: one batched call per pursuit section (≤ 100 ids). */ export function useCompanySbaBadges(companyIds) {
    const viewer = useViewerKey();
    const ids = Array.from(new Set(companyIds.filter(Boolean))).sort().slice(0, 100);
    return useQuery({
        queryKey: sbaKeys.badges(viewer, ids.join(',')),
        queryFn: async ()=>{
            const resp = await registryRecordClient.listCompanySbaBadges({
                companyIds: ids
            });
            return new Map(resp.badges.map((b)=>[
                    b.companyId,
                    b
                ]));
        },
        enabled: ids.length > 0,
        retry: false,
        staleTime: 5 * 60000
    });
}
